import { render, staticRenderFns } from "./TaxDetailsStep.component.vue?vue&type=template&id=bf4eb860&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./TaxDetailsStep.component.vue?vue&type=script&lang=ts&"
export * from "./TaxDetailsStep.component.vue?vue&type=script&lang=ts&"
import style0 from "./TaxDetailsStep.component.vue?vue&type=style&index=0&id=bf4eb860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4eb860",
  null
  
)

export default component.exports